export enum SaleActionEvent {
  FINALIZE
}
